<template>
  <v-app
      id="cewe"
      :class="{ 'backgroundwhite':backgroundwhite,'backgroundgray':backgroundgray}"
  >
    <v-navigation-drawer
        class="main-menu"
        :width="panelWidth"
        v-model="drawer"
        fixed
        :right='panelIsRight'
        app
    >
      <v-img @click="drawer=false" src="/img/logo-kruidvat.png" position="left 30px center" class="main-menu-logo" contain></v-img>
      <v-list>
        <v-list-tile to="/">
          <v-list-tile-content>
            <v-list-tile-title>Startpagina</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <i class="icon icon-kruidvat-arrow"></i>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile to="photo" class="menu-photo">
          <v-list-tile-content>
            <v-list-tile-title>Nu een foto maken</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <i class="icon icon-kruidvat-arrow"></i>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile to="hoe-werkt-het">
          <v-list-tile-content>
            <v-list-tile-title>Hoe werkt de pasfotokiosk</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <i class="icon icon-kruidvat-arrow"></i>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile to="instructies">
          <v-list-tile-content>
            <v-list-tile-title>Instructies</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <i class="icon icon-kruidvat-arrow"></i>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile to="veelgestelde-vragen">
          <v-list-tile-content>
            <v-list-tile-title>Veelgestelde vragen</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <i class="icon icon-kruidvat-arrow"></i>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile to="tips">
          <v-list-tile-content>
            <v-list-tile-title>Tips</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <i class="icon icon-kruidvat-arrow"></i>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile to="order-status" v-if="hasOrder">
          <v-list-tile-content>
            <v-list-tile-title>Bekijk bestelling</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <i class="icon icon-kruidvat-arrow"></i>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile to="service">
          <v-list-tile-content>
            <v-list-tile-title>Klantenservice</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <i class="icon icon-kruidvat-arrow"></i>
          </v-list-tile-action>
        </v-list-tile>

        <!--<v-list-tile to="over-de-app">-->
        <!--<v-list-tile-content>-->
        <!--<v-list-tile-title>Over de pasfotokiosk</v-list-tile-title>-->
        <!--</v-list-tile-content>-->
        <!--<v-list-tile-action>-->
        <!--<i class="icon icon-kruidvat-arrow"></i>-->
        <!--</v-list-tile-action>-->
        <!--</v-list-tile>-->

        <v-list-tile to="privacy">
          <v-list-tile-content>
            <v-list-tile-title>Privacy</v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <i class="icon icon-kruidvat-arrow"></i>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>

      <v-btn
          fixed
          dark
          fab
          bottom
          left
          color="dark"
          class="hidden-md-and-up v-btn--version"
      >
        <span v-text="version"></span>
      </v-btn>


      <v-btn
          fixed
          dark
          fab
          bottom
          :left='leftHanded'
          :right='!leftHanded'
          color="dark"
          class="hidden-md-and-up v-btn--navigator btn-refresh"
          @click="refresh"
      >
        <v-icon>refresh</v-icon>
      </v-btn>


      <v-btn
          fixed
          dark
          fab
          bottom
          :left='leftHanded'
          :right='!leftHanded'
          color="dark"
          class="hidden-md-and-up v-btn--navigator btn-close"
          @click="drawer=false"
      >
        <v-icon>close</v-icon>
      </v-btn>


      <v-container grid-list-md class="hidden-md-and-up">
        <v-layout row wrap align-center>
          <!--
      <v-flex xs8 align-center>
        <v-btn outline small color="grey" @click="toggleLeftHanded()" v-if="leftHanded">Ik ben rechtshandig</v-btn>
        <v-btn outline small color="grey" @click="toggleLeftHanded()" v-if="!leftHanded">Ik ben linkshandig</v-btn>
      </v-flex>
      -->
        </v-layout>
      </v-container>

    </v-navigation-drawer>

    <v-toolbar color="primary" fixed app height="80px" class="main-toolbar">
      <v-toolbar-side-icon class="hidden-sm-and-down" @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-img @click="$router.push('/')" src="/img/logo-kruidvat.png" height="50%" position="left center" contain></v-img>
      <v-toolbar-title>Pasfotokiosk</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-btn
          fixed
          dark
          fab
          bottom
          :left='leftHanded'
          :right='!leftHanded'
          color="dark"
          class="hidden-md-and-up v-btn--navigator"
          @click.stop="drawer = !drawer"
      >
        <img src="/img/icons/hamburger.png"/>
      </v-btn>
      <v-btn
          fixed
          fab
          bottom
          :right='!leftHanded'
          :class="{ 'showmenu':showmenu }"
          class="hidden-md-and-up v-btn-showmenu v-btn--menu-label"
          @click.stop="drawer = !drawer"
      >
        MENU
      </v-btn>

      <v-container fluid fill-height class="pa-0">
        <v-layout
        >
          <v-flex xs-12>
            <router-view></router-view>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>

  </v-app>
</template>

<script>
  import BackendService from "@/services/BackendService";

  export default {
    name: 'App',
    components: {},
    created() {
      this.updateApp();
    },
    mounted() {
      this.$nextTick(() => {
        window.addEventListener('resize', this.addFooterPadding);
      });
    },
    watch: {
      '$route': 'updateApp',
    },

    computed: {
      panelWidth: function () {
        let w = window.innerWidth;
        if (w < 768) {
          return w;
        } else {
          return 320;
        }
      },
      panelIsRight: function () {
        return window.innerWidth < 768 && !this.leftHanded;
      },
      hasOrder: function () {
        return localStorage.lastOrderCode && localStorage.lastOrderCode.length;
      },
      refreshedForVersion: function () {
        return localStorage.getItem('refreshed');
      }
    },
    data() {
      return {
        drawer: null,
        refreshed: false,
        showmenu: false,
        backgroundwhite: false,
        backgroundgray: false,
        version: null,
      }
    },
    methods: {
      updateApp() {
        this.version = process.env.VUE_APP_VERSION;

        this.showmenu = this.$route.path === '/';
        this.backgroundgray = this.$route.path === '/' || this.$route.path === '/hoe-werkt-het' || this.$route.path === '/instructies' || this.$route.path === '/tips' || this.$route.path === '/veelgestelde-vragen' || this.$route.path === '/over-de-app' || this.$route.path === '/service' || this.$route.path === '/privacy';
        this.backgroundwhite = this.$route.path === '/photo';

        BackendService.getAppInfo()
          .then((response) => {
            console.log(this.refreshedForVersion);
            if (process.env.VUE_APP_VERSION !== response.data.version && this.refreshedForVersion !== response.data.version) {
              //this.refresh();
              localStorage.refreshed = response.data.version;
            }
          })
      },
      refresh: function (event) {
        caches.keys().then(function (names) {
          for (let name of names) {
            caches.delete(name);
          }
          window.location.reload(true);
        });
      },
      toggleLeftHanded() {
        this.leftHanded = !this.leftHanded;
      },
    },
  }
</script>

<style>

  .btn-refresh {
    right: 100px;
  }


  .btn-close {
    right: 30px;
  }

  .v-card__text {
    font-family: 'Officina-Sans-Regular', sans-serif;
    font-size: 1.2em;
    padding: 30px 20px 20px 40px
  }


  .v-card__text strong, .v-card__text ol li:before {
    font-family: 'Officina-Sans-Bold', sans-serif;
  }

  .v-card__text ol {
    list-style: none;
    padding-left: 25px;
    counter-reset: my-awesome-counter;
  }

  .v-card__text ol li {
    counter-increment: my-awesome-counter;
    font-size: 1.2em;
  }

  .v-card__text ol li::before {
    content: counter(my-awesome-counter) "   ";
    font-size: 1.3em;
    font-weight: bold;
    margin-left: -25px;
  }

  .v-card__text ol li:last-child::before {
    display: none !important;
  }

  .v-btn--block--footer.v-btn--block--arrow .v-btn__content {
    justify-content: left;
  }

  .v-btn--create-photo {
    font-family: 'Officina-Sans-Bold', sans-serif;
    will-change: box-shadow;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    padding: 0 25px !important;
    height: 40px;
  }

  .v-btn--prev--next {
    font-family: 'Officina-Sans-Bold', sans-serif;
    will-change: box-shadow;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    border-radius: 0px !important;
  }

  .v-btn--prev--next .v-btn__content {
    justify-content: left !important;
  }

  .v-btn--block--footer {
    font-family: 'Officina-Sans-Bold', sans-serif;
    will-change: box-shadow;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    margin-bottom: 6px;
    border-radius: 0px !important;
    height: 45px;
  }

  .v-btn--navigator {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    border: 2px solid #000000 !important;
    color: #000000 !important;
    background-color: #ffffff !important;
    bottom: 24px !important;
  }

  .v-btn--version {
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    color: #7b7b7b !important;
    background-color: transparent !important;
    font-size: 0.8em;
  }

  .v-list__tile__title {
    font-size: 1.3em;
  }

  .main-toolbar .v-toolbar__title {
    font-family: 'Officina-Sans-Bold', sans-serif;
    text-transform: uppercase;
  }

  .v-toolbar.theme--light.v-toolbar.main-toolbar {
    border-bottom: 2px solid black !important;
    box-shadow: none;
  }
</style>